module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vdige7-1432dc376eba8edeaa4b5eedcdcd2b8b.jpg";